import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Usuario/getGruposUsuarioList`, method: 'POST', body: values, token: token})
}
